import { useQuery } from '@tanstack/react-query';
import { getPublishedRiflessioni, getRiflessioneBySlug } from '@/services/riflessioniService';

export const riflessioniQueryKeys = {
  all: ['riflessioni'] as const,
  list: (limit?: number) => [...riflessioniQueryKeys.all, 'list', limit ?? 'all'] as const,
  detail: (slug: string) => [...riflessioniQueryKeys.all, 'detail', slug] as const,
};

export function useRiflessioni(limit?: number) {
  return useQuery({
    queryKey: riflessioniQueryKeys.list(limit),
    queryFn: () => getPublishedRiflessioni(limit),
    staleTime: 5 * 60 * 1000,
  });
}

export function useRiflessione(slug: string) {
  return useQuery({
    queryKey: riflessioniQueryKeys.detail(slug),
    queryFn: async () => {
      const published = await getRiflessioneBySlug(slug);
      if (published) return published;
      // Non pubblicata: se chi guarda è collegato al gestionale può essere l'anteprima
      // di una bozza. Import dinamico per non portare il codice admin nelle pagine pubbliche.
      const { supabaseAuth } = await import('@/lib/supabase-auth');
      if (!supabaseAuth.getSession()) return null;
      const { getRiflessioneForPreview } = await import('@/services/adminApiService');
      return getRiflessioneForPreview(slug).catch(() => null);
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}
